export enum BlockType {
  SEQUENCE = 'marker',
  SEQUENCER = 'sequencer',
  SEQUENCE_SYSTEM = 'sequence_system',
  SEQUENCE_DEVICE = 'sequence_device',
  CUSTOM_BLOCK = 'fn_',
  VARIABLES = 'variables_',
  MODEL_POINT = 'model_point',
  POINT_SETTER = 'point_setter',
  MODEL_BLOCK = 'model_block',
  SEQUENCE_RUN_STARTUP = 'sequence_run_startup',
  MQTT_SUBSCRIBE = 'mqtt_subscribe',
  MQTT_PUBLISH = 'mqtt_publish',
  TEXT = 'text',
  TEXT_MULTILINE = 'text_multiline',
  MATH_CHANGE = 'math_change',
}

export enum Frequency {
  DAILY = 'DAILY',
  EVERY_15_MINUTES = 'EVERY_15_MINUTES',
  EVERY_5_MINUTES = 'EVERY_5_MINUTES',
  EVERY_HOUR = 'EVERY_HOUR',
  EVERY_MINUTE = 'EVERY_MINUTE',
  HOURLY = 'HOURLY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY'
}

export enum SequenceStatus {
  ENABLE = 'ENABLE',
  DISABLE = 'DISABLE',
  DISABLE_WITH_LOGS = 'DISABLE_WITH_LOGS',
  ENABLE_WITH_LOGS = 'ENABLE_WITH_LOGS',
  DRY_RUN = 'DRY_RUN'
}

export enum BlockLogo {
  IMAGE = 'assets/images/75f-block.png',
  WIDTH = 18,
  HEIGHT = 18,
  ALT_TEXT = '75F block'
}

export enum DeliveryLogsImage {
  IMAGE = 'assets/images/info-icon.png',
  WIDTH = 18,
  HEIGHT = 18,
  ALT_TEXT = 'Delivery Logs button'
}

export enum BuilderMode {
  SEQUENCE_BUILDER = 'sequence_builder',
  LIBRARY_BUILDER = 'library_builder'
}

export enum DefaultTabName {
  SITE_SEQUENCES = 'Site Sequences',
  LIBRARY_BUILDER = 'New Sequence',
}

export enum CustomCategory {
  PREDEFINED = 'Custom Primitives',
  PREDEFINED_DEVICE = 'Connect Module',
  FUNCTIONS = 'Functions',
  MODEL_POINTS = 'Model Points',
}

export enum scope {
  DEFAULT_SCOPE = 'DEFAULT_SCOPE',
  CUSTOM_SCOPE = 'CUSTOM_SCOPE'
}

export enum Category {
  CLOUD = 'CLOUD',
  SYSTEM = 'CCU',
  DEVICE = 'DEVICE'
}

export enum DefaultCategoryTabName {
  CLOUD = 'Site Sequences',
  CCU = 'System Sequences',
  DEVICE = 'Device Sequences'
}

export enum componentType {
  CLOUD = 'SITE_SEQUENCER',
  SYSTEM = 'SITE_SEQUENCER_CCU',
  DEVICE = 'SITE_SEQUENCER_DEVICE'
}

export enum DeviceRunBlockType {
  RUN_BLOCK_STARTUP = 'sequence_run_startup',
  RUN_BLOCK_CONTINUOUS = 'sequence_run_continuous'
}

export enum logsPlaceholderText {
  NO_LOGS_FOUND = 'No logs found for the sequence',
  LOGS_LOADING = 'Your request for CCU logs has been processed and should be available shortly'
}

export enum toolBoxContentKind {
  CATEGORY = 'category',
  BLOCK = 'block'
}

export enum BlockIdentifier {
  SEQUENCE = 'Sequence',
  MQTT_SUBSCRIBE = 'MQTT Subscribe'
}

export enum BlockFieldName {
  SEQUENCE_FUNCTION_NAME = 'seqFunctionName',
  VARIABLE = 'VAR',
  SELECTED_MODEL = 'selected_model',
  SELECTED_POINT_NAME = 'selected_point_name',
  SEQUENCE_ID = 'sequenceId',
  SELECTED_SCOPE_VALUE = 'selectedScopeValue',
  SEQUENCE_FUNCTION_ID = 'functionId',
  SELECTED_MODEL_ID = 'selectedModelId',
  MODEL_VERSION = 'modelVersion',
}

export enum BlocksLimitOnWorkspace {
  MODEL_BLOCKS = 8
}

export enum XMLEnum {
  DEFAULT_XML = '<xml xmlns="https://developers.google.com/blockly/xml"/>'
}

export enum OTA_Status {
  OTA_RECIEVED = 'OTA Received',
  OTA_Delivered = 'OTA Delivered',
  OTA_ERROR = 'OTA Error',
  OTA_IN_PROGRESS = 'OTA in progress'
}
